function AboutUs() {
  return (
    <div className="pt-16 px-4 md:px-8 lg:px-16 max-w-5xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center md:text-left">
        आमच्या विषयी
      </h2>
      <p className="text-gray-700 text-base md:text-lg leading-relaxed">
        श्री शिव शंभो चॅरिटेबल ट्रस्ट स्थापना भक्तांच्या श्रद्धेला एक शिस्तबद्ध
        व पारंपारिक व्यासपीठ देण्यासाठी करण्यात आली आहे. मंदिर व्यवस्थापन,
        धार्मिक विधी, सामाजिक सेवा आणि सांस्कृतिक उपक्रम यांचे नियोजनबद्ध संचालन
        करणे हा ट्रस्ट उद्देश आहे.
      </p>
    </div>
  );
}

export default AboutUs;
